import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

document.querySelectorAll('.delivery-stories-swiper-wr').forEach((el) => {
  if (el.classList.contains('is-single')) {
    return;
  }

  const swiperEl = el.querySelector('.swiper');
  const nextEl = el.querySelector('.swiper-button-next');
  const prevEl = el.querySelector('.swiper-button-prev');
  const paginationEl = el.querySelector('.swiper-pagination');

  if (!swiperEl) {
    return;
  }

  const swiper = new Swiper(swiperEl, {
    modules: [Autoplay, Navigation, Pagination],
    observer: true,
    observeParents: true,
    slidesPerView: 1,
    spaceBetween: 16,
    speed: 500,
    threshold: 10,
    navigation: {
      nextEl,
      prevEl,
    },
    pagination: {
      el: paginationEl,
      clickable: true,
    },
    breakpoints: {
      641: {
        spaceBetween: 20,
        slidesPerView: 2,
      },
      961: {
        spaceBetween: 20,
        slidesPerView: 3,
      },
      1100: {
        spaceBetween: 24,
        slidesPerView: 3,
      },
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: window.innerWidth >= 1033,
    },
  });

  swiperObserver(swiper);

  const titlesArr = swiperEl.querySelectorAll('.success-stories-card__text');
  if(titlesArr.length) {
    lineTitlesFunc(titlesArr);
  }

  const titlesSecondArr = swiperEl.querySelectorAll('.success-stories-card__title');
  if(titlesSecondArr.length) {
    lineTitlesFunc(titlesSecondArr);
  }
});
